export const REQUEST_CARD_APPLY_INFO = "REQUEST_CARD_APPLY_INFO";
